import { JsonPipe, NgClass } from '@angular/common'
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  output,
  viewChild,
} from '@angular/core'
import { MatCardModule } from '@angular/material/card'
import { MatSort, MatSortModule, Sort } from '@angular/material/sort'
import { MatTableDataSource, MatTableModule } from '@angular/material/table'

import { TranslateModule } from '@ngx-translate/core'
import { get } from 'lodash-es'

import { EPerformanceSummaryFlag, IPerformanceCore, ITableColumn } from '~/core/models'

@Component({
  selector: 'app-performance-win-table',
  templateUrl: './performance-win-table.component.html',
  styleUrl: './performance-win-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, JsonPipe, MatCardModule, MatSortModule, MatTableModule, TranslateModule],
})
export class PerformanceWinTableComponent implements AfterViewInit {
  readonly performanceRates = input<IPerformanceCore[]>([])

  // TODO: Find a common way. total, results
  readonly performanceRatesTotal = input<IPerformanceCore | null>(null)
  readonly performanceRatesResults = input<IPerformanceCore | null>(null)

  readonly sortBy = input<string>('')
  readonly order = input<'asc' | 'desc' | ''>('')

  readonly columns = input<ITableColumn[]>([])

  readonly changeSort = output<{
    sortBy: string
    order: 'asc' | 'desc' | ''
  }>()

  readonly matSort = viewChild(MatSort)

  readonly get = get
  dataSource = new MatTableDataSource<IPerformanceCore>([])

  tableColumns: ITableColumn[] = []
  displayedColumns: string[] = []

  tableColumnsFooterResults: ITableColumn[] = []
  displayedColumnsFooterResults: string[] = []

  orderBy = ''
  orderDirection: 'asc' | 'desc' | '' = ''
  performanceSummaryFlag = EPerformanceSummaryFlag

  // TODO: Find a common way. total, results
  constructor() {
    effect(() => {
      const rates = this.performanceRates()

      this.dataSource = new MatTableDataSource<IPerformanceCore>([...(rates || [])])
    })

    effect(() => {
      const cols = this.columns()

      if (cols) {
        this.tableColumns = cols
        this.tableColumnsFooterResults = cols.map(c => ({
          ...c,
          name: `footer-results-${c.name}`,
        }))

        this.displayedColumns = this.tableColumns.map(c => c.name)
        this.displayedColumnsFooterResults = this.tableColumnsFooterResults.map(c => c.name)
      }
    })
  }

  ngAfterViewInit(): void {
    const matSort = this.matSort()

    if (matSort) {
      this.dataSource.sort = matSort
    }
  }

  sortChange(sort: Sort): void {
    this.orderBy = sort.direction ? sort.active : ''
    this.orderDirection = sort.direction

    this.changeSort.emit({
      sortBy: this.orderBy,
      order: this.orderDirection,
    })
  }

  getTotalValue(name: string): any {
    const performanceRatesTotal = this.performanceRatesTotal()

    return performanceRatesTotal && name in performanceRatesTotal
      ? (performanceRatesTotal as any)[name]
      : ''
  }

  // TODO: Find a common way. total, results
  getResultsValue(name: string): any {
    const performanceRatesResults = this.performanceRatesResults()

    return performanceRatesResults && name in performanceRatesResults
      ? (performanceRatesResults as any)[name]
      : ''
  }
}
